import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./favorites.html";
import { WireStore } from '@oneappexchange/lwc-wired';
import { APPX_JP_SITE_URL, APPX_SITE_URL } from '~/modules/config';
import { getUserLanguage } from '~/modules/helpers/languageHelper';
import { Routes } from '~/modules/routes';
import { WireI18n } from '~/modules/stores/i18nStore';
import { selectIsAgentExchange, siteConfigStore } from '~/modules/stores/siteConfigStore';
import { selectSavedListingsCount, userStore } from '~/modules/stores/userStore';
import { JAPANESE_LANGUAGE_CODE } from '~/modules/utilities/language_utils';

/** Analytics menu identifier for favorites (parity with header mobile analytics). */
export const FAVORITES_MENU_IDENTIFIER = 'saved list';
class Favorites extends LightningElement {
  constructor(...args) {
    super(...args);
    this.savedListingsAltLabel = void 0;
    this.savedListingsCount = void 0;
    this.isAgentExchange = void 0;
  }
  get savedListingsUrl() {
    if (this.isAgentExchange) {
      const baseUrl = getUserLanguage() === JAPANESE_LANGUAGE_CODE ? APPX_JP_SITE_URL : APPX_SITE_URL;
      return `${baseUrl}/${Routes.FAVORITE_LISTINGS}`;
    }
    return `/${Routes.FAVORITE_LISTINGS}`;
  }
  get destinationType() {
    return this.isAgentExchange ? 'external' : 'internal';
  }

  // @ts-expect-error * Automated Type Error Fix
  handleAnalytics(event) {
    let clickUrl = '';
    const savedListingsElement = event.target.querySelector('a');
    if (savedListingsElement) {
      clickUrl = savedListingsElement.href;
    }
    event.detail.navLink = {
      menuItem: FAVORITES_MENU_IDENTIFIER,
      clickText: FAVORITES_MENU_IDENTIFIER,
      clickUrl: clickUrl,
      destinationType: this.destinationType,
      ctaClick: false
    };
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(Favorites, {
  wire: {
    savedListingsAltLabel: {
      adapter: WireI18n,
      dynamic: [],
      config: function ($cmp) {
        return {
          selector: i18n => i18n.header.favoritesAltText
        };
      }
    },
    savedListingsCount: {
      adapter: WireStore,
      dynamic: [],
      config: function ($cmp) {
        return {
          store: userStore,
          selector: selectSavedListingsCount
        };
      }
    },
    isAgentExchange: {
      adapter: WireStore,
      dynamic: [],
      config: function ($cmp) {
        return {
          store: siteConfigStore,
          selector: selectIsAgentExchange
        };
      }
    }
  }
});
const __lwc_component_class_internal = _registerComponent(Favorites, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;